<template>
  <Navbar />
  <div class="register">
    <ResetComplete />
  </div>
</template>
  
  <script setup>
import Navbar from "../components/Navbar.vue";
import { computed } from "vue";
import ResetComplete from "../components/ResetComplete.vue";
</script>
  
  
  <style scoped>
.register {
  width: 100%;
  min-height: 100vh;
  background-color: var(--color-primary-bg);
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding: 80px 32px 32px;
  box-sizing: border-box;
}

/* ✅ 手機版左右 padding 縮小 */
@media (max-width: 768px) {
  .register {
    padding: 32px 20px 24px;
  }
}
</style>
  
